import { render, staticRenderFns } from "./JobIndex.vue?vue&type=template&id=7824bbfb&"
import script from "./JobIndex.vue?vue&type=script&lang=js&"
export * from "./JobIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports